import { request, setAuthToken, clearAuthToken } from './client.js';

export async function login(email, password) {
  const res = await request('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  if (res.token) {
    await setAuthToken(res.token);
  }
  return res;
}

export async function register(email, password, displayName) {
  const res = await request('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password, displayName }),
  });
  if (res.token) {
    await setAuthToken(res.token);
  }
  return res;
}

export async function getMe() {
  return await request('/api/auth/me', {
    method: 'GET',
  });
}

export async function logout() {
  await clearAuthToken();
}
